/**
 * Devuele la extensión en minusculas de un nombre de fichero.
 *
 * @param {string} filename el nombre del fichero
 * @returns {string}
 */
export function getExtension(filename) {
  if (typeof filename !== 'string') {
    throw new TypeError(`filename must be a "string" and not a "${typeof filename}".`);
  }
  const pos = filename?.lastIndexOf('.') ?? -1;
  if (pos === -1) {
    return '';
  }
  return filename
    .substring(pos + 1, filename.length)
    .toLowerCase()
    .trim();
}
